import React, {Component} from "react";
import {Button} from "react-bootstrap";
import {getDistance} from "geolib";

export default class AddBoardPOI extends Component{
    state = {
        POI :{},
    }

    handleInputChange(event) {
        this.setState({fieldInput: event.target.value});
    }

    addPOI(){
        let POI = this.state.POI
        if(this.validPOI(POI)){
            POI.lat = parseFloat(POI.lat);
            POI.lon = parseFloat(POI.lon);
            let board = this.props.board;
            let campaign = this.props.campaign;
            if(board){
                POI.distance = getDistance(
                    {latitude:POI.lat,longitude: POI.lon},
                    {latitude:board.lat,longitude:board.lon}
                )
                board.poisArray.push(POI);
                this.props.update(board);
            }else{
                if(!campaign.POIsArray){
                    campaign.POIsArray = [];
                }
                campaign.POIsArray.push(POI);
                this.props.update(campaign);
            }
        }
        this.setState({POI: {name:"",lat:"",lon:"",category:""}})
    }
    validPOI(POI){
        return !!(POI && POI.lat && POI.lon && POI.name && POI.category);
    }
    render(){
        return <div className="compliance-issue-container">
            <div className="compliance-left">
                <div className="compliance-name w-75"><input className={"w-100"} placeholder={"Name"} value={this.state.POI.name} onChange={(ev)=>{
                    let POI = this.state.POI;
                    POI.name = ev.target.value;
                    this.setState({POI: POI});
                }}/></div>
                <div className="compliance-category"><input placeholder={"Query: "} value={this.state.POI.category}
                                                            onChange={(ev)=>{
                                                                let POI = this.state.POI;
                                                                POI.category = ev.target.value;
                                                                this.setState({POI: POI});
                                                            }}/></div>
            </div>
            <div className="compliance-distance">
                <input type={"number"} placeholder={"Lat"} value={this.state.POI.lat} onChange={(ev)=>{
                    let POI = this.state.POI;
                    POI.lat = ev.target.value;
                    this.setState({POI: POI});
                }}/>
                <input type={"number"} placeholder={"Lon"} value={this.state.POI.lon} onChange={(ev)=>{
                    let POI = this.state.POI;
                    POI.lon = ev.target.value;
                    this.setState({POI: POI});
                }}/>
            </div>
            <div className={"text-center"}>
                <Button onClick={()=>this.addPOI()} disabled={!this.validPOI(this.state.POI)} className={"btn-sm"} variant={"primary"}>
                    + Add
                </Button>
            </div>
        </div>
    }
}
